'use client';

import { useMemo } from 'react';
import { generationLock } from '../edits/guards';
import type { LayerKind } from '../contracts';
import type { OrderLayersView } from '../order/types';

/**
 * The generation lock as the workspace sees it (edits.html «Общие правила»):
 * while a layer of the story's order runs — or waits inside a running order —
 * edits wait. The write paths refuse on the server too; this only turns the
 * controls off and names the reason.
 */
export function generationLockOf(order: OrderLayersView | null | undefined): { locked: boolean; kinds: LayerKind[] } {
  if (!order) return { locked: false, kinds: [] };
  const kinds = generationLock(order.layers.map((l) => ({ storyId: '', kind: l.kind, state: l.state, orderStatus: order.status })));
  return { locked: kinds.length > 0, kinds };
}

export function useGenerationLock(order: OrderLayersView | null | undefined) {
  return useMemo(() => generationLockOf(order), [order]);
}
